import SettingsIcon from '@mui/icons-material/Settings'
import { CircularProgress, FormControlLabel, IconButton, Popover, Stack, Switch, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'

type StatsFiltersSettingsProps = {
  displayValues: boolean
  extraSettings?: React.ReactNode
  isRefetching?: boolean
  onDisplayValuesChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const StatsFiltersSettings: React.FC<StatsFiltersSettingsProps> = ({
  displayValues,
  extraSettings,
  isRefetching = false,
  onDisplayValuesChange,
}) => {
  const t = useAppTranslations()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  return (
    <>
      <Tooltip title={t('commons.settingsTitle')}>
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} size="small">
          {isRefetching ? <CircularProgress size={16} /> : <SettingsIcon />}
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Stack sx={{ gap: 2, minWidth: 220, p: 2 }}>
          <FormControlLabel
            control={<Switch color="primary" checked={displayValues} onChange={onDisplayValuesChange} />}
            label={t('stats.filter.displayValues')}
            sx={{ fontSize: '1.4rem', color: 'rgba(0, 0, 0, 0.6)', margin: 0 }}
          />
          {extraSettings}
        </Stack>
      </Popover>
    </>
  )
}

export default StatsFiltersSettings
